export const openNewTab = function(url: string) {
  window.open(url, "_blank", "noopener");
};
